import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { prinevilleConfig } from "./data";

export default function PrinevillePage() {
  return <OregonCityPageTemplate config={prinevilleConfig} />;
}